/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {Header} from './Header'
import {Navbar} from './Navbar'
import {ThemeModeSwitcher} from '../../../partials/layout/theme-mode/ThemeModeSwitcher'
import {useThemeMode} from '../../../partials/layout/theme-mode/ThemeModeProvider'
import { useAuth } from '../../../../app/modules/auth'

export function HeaderWrapper() {
  const {config, classes} = useLayout()
  const { mode } = useThemeMode()
  const { currentUser } = useAuth()
  const isDark = mode === 'dark' || document.documentElement.getAttribute('data-bs-theme') === 'dark'

  const isAgent = currentUser?.roles?.some((r: any) =>
    (r?.name || r?.roleName || r || '').toString().toLowerCase().includes('agent')
  ) ?? false

  if (!config.app?.header?.display) {
    return null
  }

  return (
    <>
      <style>
        {`
          @keyframes gradient-pan {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}
      </style>
      <div
        id='sc_app_header'
        className='app-header position-sticky top-0'
        style={{
          background: 'linear-gradient(180deg, #075293 0%, #06457d 100%)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          boxShadow: '0 4px 20px rgba(7, 82, 147, 0.35)',
          overflow: 'visible',
          zIndex: 100,
        }}
      >
        {/* Crisp Brand Red Bottom Accent Line */}
        <div 
          className='position-absolute start-0 end-0 bottom-0' 
          style={{ 
            height: '4px', 
            background: 'linear-gradient(90deg, #eb1c24 0%, #ff4d4f 50%, #eb1c24 100%)', 
            boxShadow: '0 2px 10px rgba(235, 28, 36, 0.7)',
            zIndex: 105,
            pointerEvents: 'none'
          }} 
        />
      <div
        id='sc_app_header_container'
        className={clsx(
          'app-container flex-lg-grow-1 position-relative px-4 px-lg-8',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass
        )}
        style={{ overflow: 'visible' }}
      >
        {/* Mobile sidebar toggle */}
        {config.app.sidebar?.display && !isAgent && (
          <>
            <div className='d-flex align-items-center d-lg-none ms-n2 me-2' title='Show sidebar menu'>
              <div className='btn btn-icon btn-active-color-primary w-35px h-35px' id='sc_app_sidebar_mobile_toggle'>
                <KTIcon iconName='abstract-14' className='fs-1' />
              </div>
            </div>
            <div className='position-absolute top-50 start-50 translate-middle d-lg-none'>
              <Link to='/dashboard'>
                <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo.png')} className='h-35px h-sm-40px' />
              </Link>
            </div>
          </>
        )}

        {isAgent && (
          <div className='d-flex align-items-center me-2 me-lg-4 flex-shrink-0 agent-logo-spacer' style={{ minWidth: '125px', width: '125px' }}>
            <style>
              {`
                @keyframes wavyWind {
                  0% { clip-path: path('M 0 0 L 180 0 L 180 105 C 160 105 150 95 135 95 C 120 95 110 105 90 105 C 70 105 60 95 45 95 C 30 95 20 105 0 105 Z'); }
                  25% { clip-path: path('M 0 0 L 180 0 L 180 98 C 150 98 145 90 135 90 C 115 90 105 105 90 105 C 75 105 65 90 45 90 C 30 90 20 98 0 98 Z'); }
                  50% { clip-path: path('M 0 0 L 180 0 L 180 105 C 165 105 155 92 135 92 C 125 92 110 100 90 100 C 70 100 65 95 45 95 C 25 95 15 105 0 105 Z'); }
                  75% { clip-path: path('M 0 0 L 180 0 L 180 96 C 160 96 150 92 135 92 C 125 92 115 105 90 105 C 70 105 60 92 45 92 C 20 92 15 96 0 96 Z'); }
                  100% { clip-path: path('M 0 0 L 180 0 L 180 105 C 160 105 150 95 135 95 C 120 95 110 105 90 105 C 70 105 60 95 45 95 C 30 95 20 105 0 105 Z'); }
                }
                @keyframes logoWind {
                  0% { transform: translateY(0px) rotate(0deg) skewX(0deg); }
                  25% { transform: translateY(-1px) rotate(1deg) skewX(-2deg); }
                  50% { transform: translateY(1px) rotate(-1deg) skewX(2deg); }
                  75% { transform: translateY(-1px) rotate(0.5deg) skewX(-1deg); }
                  100% { transform: translateY(0px) rotate(0deg) skewX(0deg); }
                }
                @keyframes signalPulse {
                  0% { filter: drop-shadow(0 15px 25px rgba(0,0,0,0.2)) drop-shadow(0 0 5px rgba(0, 150, 255, 0.1)); }
                  50% { filter: drop-shadow(0 15px 25px rgba(0,0,0,0.2)) drop-shadow(0 0 25px rgba(0, 150, 255, 0.6)); }
                  100% { filter: drop-shadow(0 15px 25px rgba(0,0,0,0.2)) drop-shadow(0 0 5px rgba(0, 150, 255, 0.1)); }
                }
                @keyframes logoSignal {
                  0% { filter: drop-shadow(0 2px 4px rgba(0,0,0,0.05)) drop-shadow(0 0 0px rgba(0, 150, 255, 0)); transform: scale(1); }
                  50% { filter: drop-shadow(0 2px 4px rgba(0,0,0,0.05)) drop-shadow(0 0 15px rgba(0, 150, 255, 0.6)); transform: scale(1.05); }
                  100% { filter: drop-shadow(0 2px 4px rgba(0,0,0,0.05)) drop-shadow(0 0 0px rgba(0, 150, 255, 0)); transform: scale(1); }
                }
                .agent-header-logo-badge {
                  transform: scale(0.65);
                  transform-origin: top left;
                  left: 14px;
                }
                @media (min-width: 992px) {
                  .agent-header-logo-badge {
                    transform: scale(1);
                    left: 20px;
                  }
                  .agent-logo-spacer {
                    min-width: 185px !important;
                    width: 185px !important;
                  }
                }
              `}
            </style>
            <div className="position-absolute agent-header-logo-badge" style={{ top: 0, zIndex: 105, animation: 'signalPulse 3s ease-in-out infinite' }}>
              {/* Telephone Handset Silhouette (Gagang Telepon) */}
              <Link to='/dashboard' className='position-relative d-flex align-items-center justify-content-center transition-all hover-elevate-up' 
                    style={{ 
                      width: '180px',
                      height: '105px',
                      background: 'linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(240,245,255,0.95) 100%)',
                      backdropFilter: 'blur(12px)',
                      clipPath: "path('M 0 0 L 180 0 L 180 105 C 160 105 150 95 135 95 C 120 95 110 105 90 105 C 70 105 60 95 45 95 C 30 95 20 105 0 105 Z')", 
                      paddingBottom: '20px',
                      animation: 'wavyWind 3.5s ease-in-out infinite',
                    }}>
                <img
                  alt='Logo'
                  src={toAbsoluteUrl('/media/logos/logo.png')}
                  className='h-40px h-lg-50px'
                  style={{ 
                    objectFit: 'contain', 
                    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.05))',
                    animation: 'logoWind 3.5s ease-in-out infinite, logoSignal 2s ease-in-out infinite',
                  }}
                />
              </Link>
            </div>
          </div>
        )}

        {/* Desktop logo for non-agent */}
        {!(config.layoutType === 'dark-sidebar' || config.layoutType === 'light-sidebar') && !isAgent && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15'>
            <Link to='/dashboard'>
              <img
                alt='Logo'
                src={toAbsoluteUrl('/media/logos/logo.png')}
                className='h-20px h-lg-30px app-sidebar-logo-default'
              />
            </Link>
          </div>
        )}

        {/* Main header content */}
        <div
          id='sc_app_header_wrapper'
          className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'
          style={{ overflow: 'visible' }}
        >
          {/* Left menu (non-agent only) */}
          {!isAgent && config.app.header.default?.content === 'menu' &&
            config.app.header.default.menu?.display && (
              <div
                className='app-header-menu app-header-mobile-drawer align-items-stretch'
                data-kt-drawer='true'
                data-kt-drawer-name='app-header-menu'
                data-kt-drawer-activate='{default: true, lg: false}'
                data-kt-drawer-overlay='true'
                data-kt-drawer-width='225px'
                data-kt-drawer-direction='end'
                data-kt-drawer-toggle='#sc_app_header_menu_toggle'
                data-kt-swapper='true'
                data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
                data-kt-swapper-parent="{default: '#sc_app_body', lg: '#sc_app_header_wrapper'}"
              >
                <Header />
              </div>
            )}

          {/* Right: Navbar */}
          <div className='d-flex align-items-center flex-grow-1 justify-content-end pe-3 pe-lg-5' style={{ overflow: 'visible' }}>
            <Navbar />
          </div>
        </div>
      </div>
    </div>
    </>
  )
}